import { render, staticRenderFns } from "./EmployeeRecycleBinModal.vue?vue&type=template&id=01ae479d&scoped=true&"
import script from "./EmployeeRecycleBinModal.vue?vue&type=script&lang=js&"
export * from "./EmployeeRecycleBinModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ae479d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01ae479d')) {
      api.createRecord('01ae479d', component.options)
    } else {
      api.reload('01ae479d', component.options)
    }
    module.hot.accept("./EmployeeRecycleBinModal.vue?vue&type=template&id=01ae479d&scoped=true&", function () {
      api.rerender('01ae479d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/modules/EmployeeRecycleBinModal.vue"
export default component.exports